import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import css from './CustomModal.module.css';
import Icons from '../Icons/Icons';

const CustomModal = ({ id, isOpen, onClose, children, modalTitle }) => {
  // Handle body scroll
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  ``;
  if (!isOpen) return null;

  // Render the modal in a portal
  return ReactDOM.createPortal(
    <div className={css.modalOverlay}>
      <div className={css.modalWrapper}>
        <div className={css.modal}>
          <div className={css.modalHeader}>
            <h2 className={css.modalTitle}>{modalTitle}</h2>
            <button className={css.closeButton} onClick={onClose} aria-label="Close modal">
              <span className={css.closeIcon}>
                <Icons name="cross" />
              </span>
            </button>
          </div>
          <div className={css.modalContent}>{children}</div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default CustomModal;
